(() => {
  if (customElements.get('mf-catalogue-colors')) return;
  customElements.define('mf-catalogue-colors', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) this.cleanup();
      const card = this.closest('.mf-footwear-card');
      const list = this.querySelector('.mf-colors__list');
      if (!card || !list) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const image = card.querySelector('.card__media img');
      const links = [...card.querySelectorAll('.card__heading a')];
      const price = card.querySelector('.card-information .price');
      let newHandles = [];
      try { newHandles = JSON.parse(this.dataset.newHandles || '[]') || []; } catch (_) { /* no badge on invalid settings */ }
      const badgeLayer = card.querySelector('.card__inner .mfet');
      const originalNew = Boolean(badgeLayer?.querySelector('.mfet__pill--new'));
      const updateBadge = isNew => {
        if (!badgeLayer) return;
        badgeLayer.querySelector('.mfet__pill--new')?.remove();
        if (isNew) {
          const badge = document.createElement('span');
          badge.className = 'mfet__pill mfet__pill--new';
          badge.textContent = this.dataset.newLabel || 'NEW';
          badgeLayer.prepend(badge);
        }
      };
      const original = {
        src: image?.getAttribute('src'), srcset: image?.getAttribute('srcset'), alt: image?.alt,
        links: links.map(a => ({ a, href: a.getAttribute('href'), text: a.textContent })),
        price: price?.outerHTML
      };
      const arrows = [...this.querySelectorAll('[data-direction]')];
      const update = () => arrows.forEach(button => {
        button.disabled = Number(button.dataset.direction) < 0
          ? list.scrollLeft <= 2
          : list.scrollLeft >= list.scrollWidth - list.clientWidth - 2;
      });
      const restore = () => {
        updateBadge(originalNew);
        if (image) {
          image.setAttribute('src', original.src);
          if (original.srcset) image.setAttribute('srcset', original.srcset);
          else image.removeAttribute('srcset');
          image.alt = original.alt || '';
        }
        original.links.forEach(({a, href, text}) => { a.setAttribute('href', href); a.textContent = text; });
        const currentPrice = card.querySelector('.card-information .price');
        if (currentPrice && original.price) currentPrice.outerHTML = original.price;
        this.querySelectorAll('.is-preview').forEach(a => a.classList.remove('is-preview'));
        card.classList.remove('mf-footwear-card--preview');
      };
      const show = link => {
        if (!image || !link) return;
        const handle = new URL(link.href, location.href).pathname.split('/products/')[1];
        updateBadge(newHandles.slice(0, 3).includes(handle));
        image.removeAttribute('srcset');
        image.src = link.dataset.image;
        image.alt = link.dataset.title;
        links.forEach(a => { a.href = link.href; a.textContent = link.dataset.title; });
        const currentPrice = card.querySelector('.card-information .price');
        const nextPrice = link.querySelector('template')?.content.firstElementChild;
        if (currentPrice && nextPrice) currentPrice.replaceWith(nextPrice.cloneNode(true));
        this.querySelectorAll('.is-preview').forEach(a => a.classList.remove('is-preview'));
        link.classList.add('is-preview');
        card.classList.add('mf-footwear-card--preview');
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-direction]');
        if (!button) return;
        list.scrollBy({left: Number(button.dataset.direction) * list.clientWidth * .8,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, options);
      this.addEventListener('pointerover', event => {
        if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches) show(event.target.closest('.mf-colors__link'));
      }, options);
      this.addEventListener('focusin', event => {
        const link = event.target.closest('.mf-colors__link');
        if (link) { link.scrollIntoView({block: 'nearest', inline: 'nearest'}); show(link); }
      }, options);
      card.addEventListener('pointerleave', () => { if (!card.contains(document.activeElement)) restore(); }, options);
      card.addEventListener('focusout', event => { if (!card.contains(event.relatedTarget)) restore(); }, options);
      list.addEventListener('scroll', update, {...options, passive: true});
      const observer = new ResizeObserver(update);
      observer.observe(list);
      update();
      this.cleanup = () => { controller.abort(); observer.disconnect(); restore(); };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
})();
